import http from "../services/http";

export const apiGetPrescriptions = async (params = {}) => {
  try {
    const response = await http.get("/api/doctor/prescription/list", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiGetPatients = async (params = {}) => {
  try {
    const response = await http.get("/api/doctor/patients", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiGetPrescription = async (prescriptionId) => {
  try {
    const response = await http.get("/api/doctor/prescription/list", {
      params: {
        prescription_id: prescriptionId,
      },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiCreatePrescription = async (data) => {
  try {
    const response = await http.post("/api/doctor/prescription/create", data);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiUpdatePrescription = async (prescriptionId, data) => {
  try {
    const response = await http.patch("/api/doctor/prescription/update", data, {
      params: {
        prescription_id: prescriptionId,
      },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiDeletePrescription = async (prescriptionId) => {
  try {
    const response = await http.delete(`/api/doctor/prescription/delete`, {
      params: {
        prescription_id: prescriptionId,
      },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiGetMedications = async (params = {}) => {
  try {
    const response = await http.get("/api/admin/medications/list", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
